/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Club_Message_Not_FoundInputs */

const en_us2_club_message_not_found = /** @type {(inputs: Club_Message_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That message no longer exists.`)
};

const pt_br2_club_message_not_found = /** @type {(inputs: Club_Message_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essa mensagem não existe mais.`)
};

const es_419_club_message_not_found = /** @type {(inputs: Club_Message_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ese mensaje ya no existe.`)
};

const pt_pt2_club_message_not_found = /** @type {(inputs: Club_Message_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essa mensagem já não existe.`)
};

const fr_fr2_club_message_not_found = /** @type {(inputs: Club_Message_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce message n'existe plus.`)
};

const de_de2_club_message_not_found = /** @type {(inputs: Club_Message_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Nachricht gibt es nicht mehr.`)
};

const it_it2_club_message_not_found = /** @type {(inputs: Club_Message_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quel messaggio non esiste più.`)
};

/**
* | output |
* | --- |
* | "That message no longer exists." |
*
* @param {Club_Message_Not_FoundInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const club_message_not_found = /** @type {((inputs?: Club_Message_Not_FoundInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Club_Message_Not_FoundInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_club_message_not_found(inputs)
	if (locale === "es-419") return es_419_club_message_not_found(inputs)
	if (locale === "pt-PT") return pt_pt2_club_message_not_found(inputs)
	if (locale === "fr-FR") return fr_fr2_club_message_not_found(inputs)
	if (locale === "de-DE") return de_de2_club_message_not_found(inputs)
	if (locale === "it-IT") return it_it2_club_message_not_found(inputs)
	return en_us2_club_message_not_found(inputs)
});
export { club_message_not_found as "club.message_not_found" }